export default "__VITE_ASSET__BZD_M7JF__"